import { OverviewFilter, OverviewSortState } from '../types'

export const getDefaultSort = () => ({ field: 'relevance', direction: 'asc' })

export const decodeFilter = (filter: string | undefined): OverviewFilter => {
  try {
    return filter ? JSON.parse(filter) : {}
  } catch {
    return {}
  }
}

export const encodeFilter = (sort: OverviewFilter): string => JSON.stringify(sort)

export const decodeSort = (
  sort: string | undefined,
  defaultSort: {
    field: string
    direction: string
  }
): OverviewSortState => {
  try {
    return sort ? JSON.parse(sort) : defaultSort
  } catch {
    // @ts-expect-error 'relevance' is not part of OverviewItemKey
    return defaultSort
  }
}

export const encodeSort = (sort: OverviewSortState): string => JSON.stringify(sort)

type DateFilterGroup = {
  filter: keyof OverviewFilter
  start: keyof OverviewFilter
  end: keyof OverviewFilter
}

const dateFilterGroups: ReadonlyArray<DateFilterGroup> = [
  { filter: 'deliveryDateFilter', start: 'deliveryStartDate', end: 'deliveryEndDate' },
  { filter: 'pickupDateFilter', start: 'pickupStartDate', end: 'pickupEndDate' },
  { filter: 'ETADateFilter', start: 'ETAStartDate', end: 'ETAEndDate' },
  { filter: 'ETDDateFilter', start: 'ETDStartDate', end: 'ETDEndDate' },
  { filter: 'cargoReadyDateFilter', start: 'cargoReadyStartDate', end: 'cargoReadyEndDate' },
]

const isMissing = (value: unknown): boolean => value === undefined || value === null

export const dropDatelessDateFilters = (filter: OverviewFilter): OverviewFilter => {
  const normalized = { ...filter }
  dateFilterGroups.forEach((group) => {
    if (isMissing(normalized[group.start]) && isMissing(normalized[group.end])) {
      delete normalized[group.filter]
    }
  })

  return normalized
}
